import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  Breadcrumbs,
  Button,
  Card,
  Link,
  TextField,
  Typography,
  IconButton,
  Paper,
  Modal,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../comman/SnackBarUI";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { getMetaAction } from "../../redux/toolkit/config/getmeta";
import { editMetaAction } from "../../redux/toolkit/config/editmeta";
import { getAllPartnerActionNoLimit } from "../../redux/toolkit/partner/getAllPartnerNoLimit";
import axios from "../../config/authAxios";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Checkbox from "@mui/material/Checkbox";
import AddBadge from "./AddBadge";
import { useStyles } from "../../theme/theme";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import EditBadge from "./EditBadge";
import Body from "../../layout/Body";

import { styled } from "@mui/material/styles";
// import Chip from '@mui/material/Chip';
// import Paper from '@mui/material/Paper';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';

const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={<NavigateNextIcon sx={{ color: "#fff" }} fontSize="small" />}
      aria-label="breadcrumb"
    >
      <Link underline="hover" sx={{ color: "#fff" }} color="inherit" href="/">
        Home
      </Link>
      
    </Breadcrumbs>
    
  </Stack>
);

// schema
const qns_ans_schema = yup.object().shape({}).required();

export default function Config() {
  // state
  const {
    register,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(qns_ans_schema),
    defaultValues: {},
  });

//   const mission_type = watch("mission_type");
  const dispatch = useDispatch();
  const navigate = useNavigate();
//   const createMission = useSelector((state) => state.createMission);
//   const {
//     status: createMissionStatus,
//     message: createMissionMsg,
//     loading: createMissionLoading,
//   } = createMission;
//   const getCat = useSelector((state) => state.getCategory);
//   const getQns = useSelector((state) => state.getMissionQns);

  const getMeta = useSelector((state) => state.getMeta);
  const { data } = getMeta;

  const editMeta = useSelector((state) => state.editMeta);
  const { data: editData, status: editStatus, message: editMessage } = editMeta;

  const [configId, setConfigId] = useState();
  const [snack, setSnack] = useState(false);
  const [MaintinanceMode, setMaintinanceMode] = useState();
  const [theme, setTheme] = React.useState(1);
  const [showAlert, setShowAlert] = useState(false);
  const [badgeOpen, setBadgeOpen] = useState(false);
  const [editBadgeOpen, setEditBadgeOpen] = useState(false);

  const [editBadgeData, setEditBadgeData] = useState({});
  const [badgeIndex, setBadgeIndex] = useState(0);

  const [deleteBadgeOpen, setDeleteBadgeOpen] = useState(false);

  const [chipData, setChipData] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const [partnerUpdateStatus, setPartnerUpdateStatus] = useState(null);
  const [partnerUpdateMessage, setPartnerUpdateMessage] = useState("");

//   const classes = useStyles();

  // fn

  const handleUpdatePartnerConfigs = async () => {
    try {
      const response = await axios.post("/admins/api/updatePartnersHomepageConfig", {
        partners: partnerConfigs.map((partner) => ({
          partnerId: partner._id,
          homepage_config: {
            survey_order: partner.survey_order,
            survey_limit: partner.survey_limit,
          },
        })),
      });

      if (response?.data?.status === 200) {
        setPartnerUpdateStatus(response?.data?.status);
        setPartnerUpdateMessage(response?.data?.message || "Partner configuration updated successfully");
        setSnack(true);
        dispatch(getAllPartnerActionNoLimit({}));
      }
    } catch (error) {
      console.error("Error updating partner configs:", error);
      setPartnerUpdateStatus(500);
      setPartnerUpdateMessage(error?.response?.data?.message || "Failed to update partner configuration");
      setSnack(true);
    }
  };

  const handleConfigMeta = async (data) => {
    data.config_id = configId;
    data.is_maintinance_mode = MaintinanceMode;
    data.quizwall_io_theme = theme;
    data.survey_prefrence = surveyPreferences;
    data.partner_prefrence = partnerPreferences;
    data.badge = badges;
    data.spin_earn_limit = chipData;

    const editMetaData = await dispatch(editMetaAction(data));
    if (editMetaData?.payload?.status == 201) {
      // await dispatch(getMissionAction({ is_deleted: false }))
      setSnack(true);
      reset();
      navigate("/config-meta");
      dispatch(getMetaAction());
    }

    setSnack(true);
    // setState(false)
  };

  const handleClose = function () {
    setDeleteBadgeOpen(false);
    // reset()
    // navigate('/mission')
  };

  const [surveyPreferences, setSurveyPreferences] = useState([]);

  const [partnerPreferences, setPartnerPreferences] = useState([]);

  const allPartnersSelector = useSelector((state) => state.allPartnerWithoutLimit);
  const { data: allPartnersData } = allPartnersSelector;

  const [partnerConfigs, setPartnerConfigs] = useState([]);

  const handleCheckboxChange = (id) => {
    setSurveyPreferences((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const partnerCheckboxChange = (id) => {
    setPartnerPreferences((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };

  const handlePartnerConfigChange = (partnerId, field, value) => {
    setPartnerConfigs((prev) =>
      prev.map((partner) =>
        partner._id === partnerId
          ? { ...partner, [field]: Number(value) || 0 }
          : partner
      )
    );
  };

  let preferenceName = {
    0: "PureSpectrum",
    1: "Cpx",
    2: "BitLab",
    3: "Wannads",
    4: "EasySurvey",
    5: "Shushi",
    6: "Cint",
    7: "Mxcel",
  };

  let partnerPreferenceName = {
    0: "PureSpectrum",
    1: "Cpx",
    2: "BitLab",
    3: "Wannads",
    4: "EasySurvey",
    5: "Shushi",
    6: "Cint",
    7: "Pollreach",
    8: "Polltastic",
    9: "Opinion Universe",
    10: "Timewall",
    11: "Mxcel",
  };

  useEffect(() => {
    dispatch(getMetaAction());
    dispatch(getAllPartnerActionNoLimit({}));
  }, [dispatch]);

  // Initialize partnerConfigs when partners are loaded
  useEffect(() => {
    if (allPartnersData && allPartnersData.length > 0) {
      const initialConfigs = allPartnersData.map((partner) => ({
        _id: partner._id,
        name: partner.name,
        survey_order: partner.homepage_config?.survey_order || 0,
        survey_limit: partner.homepage_config?.survey_limit || 0,
      }));
      setPartnerConfigs(initialConfigs);
    }
  }, [allPartnersData]);

  // Reset partner update status when snackbar is closed
  useEffect(() => {
    if (!snack) {
      setPartnerUpdateStatus(null);
      setPartnerUpdateMessage("");
    }
  }, [snack]);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.app_name = data.app_name;
    defaultValues.support_email = data.support_email;
    defaultValues.support_mobile = data.support_mobile;
    defaultValues.is_maintinance_mode = data.is_maintinance_mode;
    defaultValues.daily_user_attempt_limit = data.daily_user_attempt_limit;
    defaultValues.daily_mission_attempt_limit =
      data.daily_mission_attempt_limit;
    defaultValues.redirect_mission_id = data.redirect_mission_id;
    defaultValues.survey_prefrence = data.survey_prefrence;
    defaultValues.partner_prefrence = data.partner_prefrence;
    defaultValues.partner_sequence = data.partner_sequence;
    // defaultValues.ipSurveyLimit = data.ipSurveyLimit;
    defaultValues.user_survey_limit = data.user_survey_limit;
    defaultValues.profiler_complete_amount = data.profiler_complete_amount;

    // defaultValues.completedSurveyLimit = data.completedSurveyLimit;
    // defaultValues.attemptedSurveyLimit = data.attemptedSurveyLimit;
    // defaultValues.callBackIpSurveyLimit = data.callBackIpSurveyLimit;
    // defaultValues.callBackCompletedSurveyLimit =
    //   data.callBackCompletedSurveyLimit;
    // defaultValues.callBackAttemptedSurveyLimit =
    //   data.callBackAttemptedSurveyLimit;
    defaultValues.minimumPublisherPayoutLimit =
      data.minimumPublisherPayoutLimit;
    defaultValues.partnersNumber = data.partnersNumber;
    defaultValues.minuserwithdraw = data.minuserwithdraw || 0;
    defaultValues.max_user_withdraw = data.max_user_withdraw || 0;
    defaultValues.number_of_time_withdraw = data.number_of_time_withdraw || 0;
    defaultValues.exchange_rate = data.exchange_rate || 0;

    setSurveyPreferences(data?.survey_prefrence);
    setPartnerPreferences(data?.partner_prefrence);

    setBadges(data?.badge);
    setChipData(data?.spin_earn_limit);

    setMaintinanceMode(data.is_maintinance_mode);
    setTheme(data.quizwall_io_theme);
    setConfigId(data?._id);
    reset({ ...defaultValues });
  }, [dispatch, data]);

  const handleChange = () => {
    setMaintinanceMode(!MaintinanceMode);
  };

  const handleChange2 = (event) => {
    setTheme(event.target.value);
  };

  const [badges, setBadges] = useState([]);

  const handleAddBadge = (newBadge) => {
    setBadges((prevBadges) => [...prevBadges, newBadge]);
  };

  const handleEditBadge = (editBadgeData, i) => {
    // setBadges((prevBadges) => [...prevBadges, editBadgeData]);
    setBadges((prevBadge) =>
      prevBadge.map((badge, index) => (index === i ? editBadgeData : badge))
    );
  };

  const handleDeleteBadge = () => {
    let tempbadge = [...badges];
    tempbadge.splice(badgeIndex, 1);
    setBadges(tempbadge);
    setDeleteBadgeOpen(false);
    setBadgeIndex(0);
  };

  const handleDelete = (chipToDelete) => () => {
    setChipData((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  const handleAdd = () => {
    const num = Number(inputValue);
    if (!isNaN(num)) {
      setChipData([...chipData, num]);
      setInputValue("");
    }
  };

  return (
    <>
      <Card sx={{ p: 5 }}>
        <Typography variant="h5" sx={{ mb: 5 }}>
          Config Meta
        </Typography>
        <form onSubmit={handleSubmit(handleConfigMeta)}>
          <Stack spacing={3}>
            <Stack
              sx={{
                boxShadow: 3, // Adds a subtle shadow
                padding: 2, // Adds some padding
                borderRadius: 2, // Rounds the corners slightly
                "&:hover": {
                  boxShadow: 6, // Increases the shadow on hover
                },
                transition: "box-shadow 0.3s ease-in-out",
              }}
              direction="row"
              spacing={5}
            >
              <TextField
                label="App Name"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.app_name}
                error={errors?.app_name?.message}
                helperText={errors?.app_name?.message}
                {...register("app_name")}

              />
              <TextField
                label="Support Mobile"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.support_mobile}
                error={errors?.support_mobile?.message}
                helperText={errors?.support_mobile?.message}
                {...register("support_mobile")}
              />
              <TextField
                label="Support Email"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.support_email}
                error={errors?.support_email?.message}
                helperText={errors?.support_email?.message}
                {...register("support_email")}
              />
            </Stack>

            <Stack
              sx={{
                boxShadow: 3,
                padding: 2,
                borderRadius: 2,
                transition: "box-shadow 0.3s ease-in-out",
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)", // 4 items per row
                gap: 2, // Spacing between items
                width: "100%", // Full container width
              }}
            >
              <TextField
                label="Partner Sequence"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.partner_sequence}
                error={errors?.partner_sequence?.message}
                helperText={errors?.partner_sequence?.message}
                {...register("partner_sequence")}
                sx={{marginBottom: 2}}
              />

              <TextField
                label="User Survey Limit"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.user_survey_limit}
                error={errors?.user_survey_limit?.message}
                helperText={errors?.user_survey_limit?.message}
                {...register("user_survey_limit")}
                sx={{marginBottom: 2}}

              />

              <TextField
                label="Profiler Complete Amount"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.profiler_complete_amount}
                error={errors?.profiler_complete_amount?.message}
                helperText={errors?.profiler_complete_amount?.message}
                {...register("profiler_complete_amount")}
                sx={{marginBottom:2}}

              />

              <TextField
                label="Minimum PublisherPayout Limit"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.minimumPublisherPayoutLimit}
                error={errors?.minimumPublisherPayoutLimit?.message}
                helperText={errors?.minimumPublisherPayoutLimit?.message}
                {...register("minimumPublisherPayoutLimit")}
                sx={{marginBottom: 2}}

              />

              <TextField
                label="Partner Number"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.partnersNumber}
                error={errors?.partnersNumber?.message}
                helperText={errors?.partnersNumber?.message}
                {...register("partnersNumber")}
                // sx={{marginBottom: 2}}
              />

              <TextField
                label="Min User Withdraw Limit"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.minuserwithdraw}
                error={errors?.minuserwithdraw?.message}
                helperText={errors?.minuserwithdraw?.message}
                {...register("minuserwithdraw")}
                // sx={{marginBottom: 2}}
              />

              <TextField
                label="Max User Withdraw Limit"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.max_user_withdraw}
                error={errors?.max_user_withdraw?.message}
                helperText={errors?.max_user_withdraw?.message}
                {...register("max_user_withdraw")}
                // sx={{marginBottom: 2}}
              />

              <TextField
                label="Number Of Time Withdraw"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.number_of_time_withdraw}
                error={errors?.number_of_time_withdraw?.message}
                helperText={errors?.number_of_time_withdraw?.message}
                {...register("number_of_time_withdraw")}
                // sx={{marginBottom: 2}}
               
              />

              <TextField
                label="Exchange Rate"
                InputLabelProps={{ shrink: true }}
                defaultValue={data?.exchange_rate}
                error={errors?.exchange_rate?.message}
                helperText={errors?.exchange_rate?.message}
                {...register("exchange_rate")}
                sx={{marginBottom: 2}}

              />

              {/* Add more fields here, they will wrap automatically */}
            </Stack>

            <Stack
              direction="row"
              sx={{
                boxShadow: 3,
                padding: 2,
                borderRadius: 2,
                transition: "box-shadow 0.3s ease-in-out",
                display: "flex",
                // justifyContent:"center",
                alignItems: "center",
              }}
            >
              <TextField
                label="spin Earn Limit"
                variant="outlined"
                size="small"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <Button
                variant="contained"
                onClick={handleAdd}
                sx={{ ml: 1, height: "30px" }}
              >
                Add
              </Button>
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 2,
                }}
                component="ul"
              >
                {chipData?.map((data) => (
                  <ListItem key={data}>
                    <Chip label={data} onDelete={handleDelete(data)} />
                  </ListItem>
                ))}
              </Paper>
            </Stack>

            {/* Partner Homepage Config Section */}
            <Stack
              sx={{
                boxShadow: 3,
                padding: 2,
                borderRadius: 2,
                transition: "box-shadow 0.3s ease-in-out",
                margin: "20px 0px 0px 20px",
              }}
            >
              <Typography variant="h6" gutterBottom sx={{ marginBottom: 2 }}>
                Partner Homepage Configuration
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>Partner Name</strong></TableCell>
                      <TableCell align="center"><strong>Survey Order</strong></TableCell>
                      <TableCell align="center"><strong>Survey Limit</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {partnerConfigs.map((partner) => (
                      <TableRow key={partner._id}>
                        <TableCell>{partner.name}</TableCell>
                        <TableCell align="center">
                          <TextField
                            type="number"
                            size="small"
                            value={partner.survey_order}
                            onChange={(e) =>
                              handlePartnerConfigChange(
                                partner._id,
                                "survey_order",
                                e.target.value
                              )
                            }
                            sx={{ width: 100 }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            type="number"
                            size="small"
                            value={partner.survey_limit}
                            onChange={(e) =>
                              handlePartnerConfigChange(
                                partner._id,
                                "survey_limit",
                                e.target.value
                              )
                            }
                            sx={{ width: 100 }}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
                <Button variant="contained" onClick={handleUpdatePartnerConfigs}>
                  Update Partner Configuration
                </Button>
              </Stack>
            </Stack>

            <Stack
              direction="row"
              sx={{
                boxShadow: 3,
                padding: 2,
                borderRadius: 2,
                transition: "box-shadow 0.3s ease-in-out",
                margin: "20px 0px 0px 20px",
              }}
              spacing={3}
            >
              <Stack sx={{ width: "50%" }}>
                <Typography variant="h6" gutterBottom sx={{ marginBottom: 0 }}>
                  Partner Preference
                </Typography>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <FormGroup
                      row // This makes the checkboxes appear in a row
                      sx={{ display: "flex", flexDirection: "row", gap: 1 }} // Optional styling for spacing
                    >
                      <FormControlLabel
                        checked={partnerPreferences?.includes(0)}
                        control={<Checkbox />}
                        label="PureSpectrum"
                        onChange={() => partnerCheckboxChange(0)}
                      />
                      <FormControlLabel
                        checked={partnerPreferences?.includes(1)}
                        control={<Checkbox />}
                        label="Cpx"
                        onChange={() => partnerCheckboxChange(1)}
                      />
                      <FormControlLabel
                        checked={partnerPreferences?.includes(2)}
                        control={<Checkbox />}
                        label="BitLab"
                        onChange={() => partnerCheckboxChange(2)}
                      />
                      <FormControlLabel
                        checked={partnerPreferences?.includes(3)}
                        control={<Checkbox />}
                        label="Wannads"
                        onChange={() => partnerCheckboxChange(3)}
                      />
                      <FormControlLabel
                        checked={partnerPreferences?.includes(4)}
                        control={<Checkbox />}
                        label="EasySurvey"
                        onChange={() => partnerCheckboxChange(4)}
                      />
                      <FormControlLabel
                        checked={partnerPreferences?.includes(5)}
                        control={<Checkbox />}
                        label="Shushi"
                        onChange={() => partnerCheckboxChange(5)}
                      />
                      <FormControlLabel
                        checked={partnerPreferences?.includes(6)}
                        control={<Checkbox />}
                        label="Cint"
                        onChange={() => partnerCheckboxChange(6)}
                      />

                      <FormControlLabel
                        checked={partnerPreferences?.includes(7)}
                        control={<Checkbox />}
                        label="Pollreach"
                        onChange={() => partnerCheckboxChange(7)}
                      />

                      <FormControlLabel
                        checked={partnerPreferences?.includes(8)}
                        control={<Checkbox />}
                        label="Polltastic"
                        onChange={() => partnerCheckboxChange(8)}
                      />

                      <FormControlLabel
                        checked={partnerPreferences?.includes(9)}
                        control={<Checkbox />}
                        label="Opinion Universe"
                        onChange={() => partnerCheckboxChange(9)}
                      />

                      <FormControlLabel
                        checked={partnerPreferences?.includes(10)}
                        control={<Checkbox />}
                        label="Timewall"
                        onChange={() => partnerCheckboxChange(10)}
                      />

                      <FormControlLabel
                        checked={partnerPreferences?.includes(11)}
                        control={<Checkbox />}
                        label="Mxcel"
                        onChange={() => partnerCheckboxChange(11)}
                      />
                    </FormGroup>
                  </FormControl>
                </Box>
              </Stack>

              <Stack direction="column">
                <Typography variant="h6" gutterBottom sx={{ marginBottom: 0 }}>
                  Partner Preference Order
                </Typography>

                <Stack direction="column" spacing={1} flexWrap="wrap">
                  {" "}
                  {/* Added flexWrap */}
                  {partnerPreferences?.map((item, i) => (
                    <Chip
                      key={i}
                      label={partnerPreferenceName[item]}
                      variant="outlined"
                      sx={{ marginBottom: "10px" }}
                    />
                  ))}
                </Stack>
              </Stack>
            </Stack>





            

            <Stack
              sx={{
                boxShadow: 3,
                padding: 2,
                borderRadius: 2,
                transition: "box-shadow 0.3s ease-in-out",
                margin: "20px 0px 0px 20px",
              }}
              direction="column"
              spacing={2}
            >
              <Button
                onClick={() => setBadgeOpen(true)}
                sx={{ width: "fit-content" }}
                variant="contained"
              >
                Add Badge
              </Button>

              <Card sx={{ my: 2 }}>
                <Stack direction={"row"} alignItems="center" sx={{ ml: 1 }}>
                  <Typography sx={{ my: 1 }} variant="h6">
                    Badge List
                  </Typography>
                </Stack>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Name</TableCell>
                        <TableCell align="center">Reward Limit</TableCell>
                        <TableCell align="center">Description</TableCell>
                        <TableCell align="center">Image</TableCell>
                        <TableCell align="center">Edit</TableCell>
                        <TableCell align="center">Delete</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {badges?.map((row, i) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell align="center">{row?.name}</TableCell>
                          <TableCell align="center">
                            {row?.reward_limit}
                          </TableCell>
                          <TableCell align="center">
                            {row?.description}
                          </TableCell>
                          <TableCell align="center">
                            <img src={row?.image} alt="Badge" width="50" />
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => {
                                setEditBadgeData(row);
                                setBadgeIndex(i);
                                setEditBadgeOpen(true);
                              }}
                              color="#071D45"
                            >
                              <FilterAltIcon />
                            </IconButton>
                          </TableCell>
                          <TableCell align="center">
                            <IconButton aria-label="delete">
                              <DeleteIcon
                                onClick={() => {
                                  setBadgeIndex(i);
                                  setDeleteBadgeOpen(true);
                                }}
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Stack>

            

            <Body>
              <Modal
                sx={{ overflow: "scroll" }}
                open={deleteBadgeOpen}
                onClose={handleClose}
              >
                <Box className="modal_box">
                  <Card sx={{ width: 500, p: 5 }}>
                    <Typography variant="h5" sx={{ mb: 5 }} align="center">
                      Are You Sure You Want To Delete Badge
                    </Typography>

                    <Stack
                      direction="row"
                      sx={{ display: "flex", justifyContent: "space-around" }}
                      spacing={5}
                      mt={3}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        onClick={() => handleDeleteBadge()}
                      >
                        Yes
                      </Button>

                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        NO
                      </Button>
                    </Stack>
                  </Card>
                </Box>
              </Modal>

              {/* <SnackBarUI state={snack} setState={setSnack} status={status} message={message} /> */}
            </Body>

            <Stack direction="row" spacing={2}>
              <Button variant="contained" type="submit">
                {"Update Config Meta"}
              </Button>
              <Button variant="contained" color="error" onClick={handleClose}>
                Back
              </Button>
            </Stack>
          </Stack>
        </form>
      </Card>

      {badgeOpen && (
        <AddBadge
          state={badgeOpen}
          setState={setBadgeOpen}
          onAddBadge={handleAddBadge}
        />
      )}

      {editBadgeOpen && (
        <EditBadge
          state={editBadgeOpen}
          setState={setEditBadgeOpen}
          onAddBadge={handleEditBadge}
          editBadgeData={editBadgeData}
          index={badgeIndex}
        />
      )}

      <SnackBarUI
        state={snack}
        setState={setSnack}
        status={partnerUpdateStatus || editStatus}
        message={partnerUpdateMessage || editMessage}
      />
    </>
  );
}


